import { skipToken } from '@tanstack/react-query';
import { trpc } from '@portal/trpc/client';

export const useResourceAccessRules = (resourceId?: number) => {
  return trpc.nexudus.getResourceAccessRule.useQuery(
    resourceId == null ? skipToken : { id: resourceId },
    {
      staleTime: 1000 * 60,
    },
  );
};

export const useResourceAccessTimeSlots = (resourceAccessRuleId?: number) => {
  return trpc.nexudus.getResourceAccessTimeSlots.useQuery(
    resourceAccessRuleId == null ? skipToken : { id: resourceAccessRuleId },
    {
      staleTime: 1000 * 60,
    },
  );
};
